module.exports = __webpack_public_path__ + "media/images/apply4_new_logo-835c4b8a.png";